import type { AllRouteEndpoints } from "../routeTypes";
import { cacheKey as teamData } from "../teamData";
import { cacheKey as teamsData } from "../teamsData";
export const appsAppGroupIdTerritoriesUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [teamsData, teamData];
